import { request } from '@ui/api/v2/api';

export interface ISoap {
  id: number;
  catalog: string;
  database: string;
  server: string;
  login: string;
  password: string;
}

export interface ISoapBody {
  catalog: string;
  database: string;
  server: string;
  login: string;
  password: string;
}

export function getSoap() {
  return request<ISoap>('get', 'soap');
}

export function createSoap(data: ISoapBody) {
  return request('post', 'soap', data);
}

export function updateSoap(id: number, data: ISoapBody) {
  return request('patch', `soap/${id}`, data);
}



// WEBPACK FOOTER //
// ./src/api/v2/soap.api.ts